import lrFormItem from './_src/lrFormItem.vue'

lrFormItem.install = function(Vue) {
  Vue.component(lrFormItem.name, lrFormItem)
}

export default lrFormItem